export default __webpack_public_path__ + "static/media/PT.f560d0d8.svg";